import { useCallback } from 'react'

import {
  POST_SALE_TYPES_REPLACE,
  convertResult,
  convertParams,
} from 'app/common/api/requests/food/items/delete_and_replace_sale_types/post'

import { ReplaceParams, SaleTypeId } from 'app/dataTypes/dishes/saleType'
import useCallbackRef from 'app/common/hooks/useCallbackRef'
import { api } from 'app/api'


export function useReplaceSaleType(onSuccess?: (saleTypeIds: Array<SaleTypeId>) => void) {
  const onSuccessRef = useCallbackRef(onSuccess)

  const handleReplaceSaleType = useCallback(async (params: ReplaceParams) => {
    const res = await api.request(POST_SALE_TYPES_REPLACE, {
      error: 'Не удалось удалить тип(ы) продукции',
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      onSuccessRef.current?.(params.map(({ id }) => id))
    }

    return res
  }, [onSuccessRef])

  return handleReplaceSaleType
}
